import { Factory, association, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  approvalStatus: association(),
  location: association(),
  visitor: association(),

  additionalGuests: 0,
  arrived: false,
  fullName: faker.person.firstName(),
  isPresigned: false,
  touchlessSignInPresenceRequired: false,
  preregistrationLink: 'https://www.fakelink.com',
  expectedArrivalTime: Date.now(),

  afterCreate(invite, server) {
    const userData = server.createList('graphql/user-data', 3);
    const location = server.create('graphql/location');
    invite.update({ userData, location });
  },

  asDenied: trait({
    approvalStatus: association({ status: 'denied' }),
  }),
  asRegistered: trait({
    isPresigned: true,
    preregistrationLink: null,
    approvalStatus: association({ status: 'approved' }),
  }),
  withEntry: trait({
    entry: association(),
  }),
});
